// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { AddDocumentsRoutingModule } from './add-documents-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { AddDocumentsComponent } from './pages/add-documents/add-documents.page';

// Custom packages - Components

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    AddDocumentsRoutingModule,
    // PublicModule,
  ],
  declarations: [
    AddDocumentsComponent,
  ],
  entryComponents: [
  ],
  // exports: [
  //   dialogs here
  // ]
})
export class AddDocumentsModule { }
